import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Activity, TrendingUp, AlertCircle, CheckCircle2 } from 'lucide-react';
import WorkflowRunsTable from './WorkflowRunsTable';
import RunsChart from './RunsChart';
import { MonitoringMetrics, MonitoringTimeSeries } from '@/types/agents';

// Mock data - replace with actual API calls
const mockMetrics: MonitoringMetrics = {
    totalRuns: 1247,
    successfulRuns: 1156,
    failedRuns: 78,
    runningRuns: 13,
    averageDuration: 45.2,
};

const mockTimeSeries: MonitoringTimeSeries[] = [
    { timestamp: '2024-01-01T00:00:00Z', runs: 45, successes: 42, failures: 3 },
    { timestamp: '2024-01-01T01:00:00Z', runs: 52, successes: 48, failures: 4 },
    { timestamp: '2024-01-01T02:00:00Z', runs: 38, successes: 36, failures: 2 },
    { timestamp: '2024-01-01T03:00:00Z', runs: 41, successes: 39, failures: 2 },
    { timestamp: '2024-01-01T04:00:00Z', runs: 49, successes: 46, failures: 3 },
    { timestamp: '2024-01-01T05:00:00Z', runs: 55, successes: 52, failures: 3 },
    { timestamp: '2024-01-01T06:00:00Z', runs: 62, successes: 59, failures: 3 },
];

const Monitoring: React.FC = () => {

    return (
        <div className="space-y-6">
            {/* Metrics Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                <Card>
                    <CardHeader className="pb-2">
                        <CardTitle className="text-sm font-medium flex items-center">
                            <Activity className="h-4 w-4 mr-2 text-primary" />
                            Total Runs
                        </CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="text-2xl font-bold text-primary">
                            {mockMetrics.totalRuns.toLocaleString()}
                        </div>
                    </CardContent>
                </Card>

                <Card>
                    <CardHeader className="pb-2">
                        <CardTitle className="text-sm font-medium flex items-center">
                            <CheckCircle2 className="h-4 w-4 mr-2 text-secondary" />
                            Successful
                        </CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="text-2xl font-bold text-secondary">
                            {mockMetrics.successfulRuns.toLocaleString()}
                        </div>
                        <div className="text-xs mt-1 text-muted-foreground">
                            {((mockMetrics.successfulRuns / mockMetrics.totalRuns) * 100).toFixed(1)}%
                        </div>
                    </CardContent>
                </Card>

                <Card>
                    <CardHeader className="pb-2">
                        <CardTitle className="text-sm font-medium flex items-center">
                            <AlertCircle className="h-4 w-4 mr-2 text-destructive" />
                            Failed
                        </CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="text-2xl font-bold text-destructive">
                            {mockMetrics.failedRuns.toLocaleString()}
                        </div>
                        <div className="text-xs mt-1 text-muted-foreground">
                            {((mockMetrics.failedRuns / mockMetrics.totalRuns) * 100).toFixed(1)}%
                        </div>
                    </CardContent>
                </Card>

                <Card>
                    <CardHeader className="pb-2">
                        <CardTitle className="text-sm font-medium text-foreground">
                            Avg Duration
                        </CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="text-2xl font-bold text-primary">
                            {mockMetrics.averageDuration.toFixed(1)}s
                        </div>
                    </CardContent>
                </Card>
            </div>

            {/* Charts */}
            <div className="grid grid-cols-1 lg:grid-cols-1 gap-6">
                <Card>
                    <CardHeader>
                        <CardTitle className="flex items-center">
                            <TrendingUp className="h-5 w-5 mr-2" />
                            Execution Trends
                        </CardTitle>
                    </CardHeader>
                    <CardContent>
                        <RunsChart data={mockTimeSeries} />
                    </CardContent>
                </Card>
            </div>

            {/* Workflow Runs Table */}
            <Card>
                <CardHeader>
                    <CardTitle className="flex items-center">
                        <Activity className="h-5 w-5 mr-2" />
                        Execution History
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    <WorkflowRunsTable />
                </CardContent>
            </Card>
        </div>
    );
};

export default Monitoring;

